import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

// Get all events
const getEvents = async () => {
  const response = await axios.get(`${base_url}event/`);
  return response.data;
};

// Create a new event
const createEvent = async (event) => {
  const response = await axios.post(`${base_url}event/`, event, config);
  return response.data;
};

// Get a single event
const getEvent = async (id) => {
  const response = await axios.get(`${base_url}event/${id}`, config);
  return response.data;
};

// Update an event
const updateEvent = async (event) => {
  const response = await axios.put(
    `${base_url}event/${event.id}`,
    {
      title: event.eventData.title,
      description: event.eventData.description,
      category: event.eventData.category,
      speaker: event.eventData.speaker,
      duration: event.eventData.duration,
      date: event.eventData.date,
      location: event.eventData.location,
      price: event.eventData.price,
      language: event.eventData.language,
      skillLevel: event.eventData.skillLevel,
      isFeatured: event.eventData.isFeatured,
      images: event.eventData.images,
      aboutEvent: event.eventData.aboutEvent,
      whatYouWillEarn: event.eventData.whatYouWillEarn,
    },
    config
  );
  return response.data;
};

// Delete an event
const deleteEvent = async (id) => {
  const response = await axios.delete(`${base_url}event/${id}`, config);
  return response.data;
};

const eventService = {
  getEvents,
  createEvent,
  getEvent,
  updateEvent,
  deleteEvent,
};

export default eventService;
